import React from "react";
import { View } from "react-native";
import { Icon, Text } from "components";

import css from "styles";
import { mq } from "utils";
import { strings } from "assets/constants";

export default function ChatEmpty() {
  return (
    <View style={{ ...css.centralElContainer, transform: [{ scaleY: -1 }] }}>
      <Icon name="search" style={{ marginBottom: mq(20) }} />
      <Text>{strings.not_exists_any_info}</Text>
    </View>
  );
}
